import { Component, Input, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements AfterViewInit {

    // the text that need to be put in the container
    @Input() text: string;

    // maximum height of the container
    @Input() maxHeight = 80;

    // set these to false to get the height of the expended container
    public isCollapsed = false;
    public isCollapsible = false;

    constructor(private elementRef: ElementRef) {
    }

    ngAfterViewInit() {
        const currentHeight = this.elementRef.nativeElement.getElementsByTagName('div')[0].offsetHeight;
        // Collapse able only if the contents make container exceed the max height
        if (currentHeight > this.maxHeight) {
            setTimeout(() => {
                this.isCollapsed = true;
                this.isCollapsible = true;
            }, 100);
        }
    }
}
